/**
 * Лёгкое описание подложки: воркер сам скачивает и декодирует картинку или GIF, главному потоку
 * нужны только адрес и размеры. destroy() оставлен как no-op ради прежнего контракта кэша.
 */
export interface BackgroundSource {
  readonly url: string;
  readonly width: number;
  readonly height: number;
  destroy(): void;
}

export async function createBackgroundSource(image: HTMLImageElement): Promise<BackgroundSource> {
  return {
    url: image.src,
    width: image.naturalWidth || image.width,
    height: image.naturalHeight || image.height,
    destroy() {},
  };
}
